import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import ListingCard from '../components/ListingCard';
import SearchFilters from '../components/SearchFilters';
import PropertyTypeCounter from '../components/PropertyTypeCounter';
import InteractivePropertyMap from '../components/InteractivePropertyMap';
import Footer from '../components/Footer';
import InvestmentNotFound from '../components/InvestmentNotFound';
import { useSearch } from '../contexts/SearchContext';
import { sendPropertySelected } from '../utils/iframeMessenger';
import './PropertyListingFilter.css';

function PropertyListingContent() {
  const { properties, allPropertiesForMap, filteredProperties, loading, error, investmentData, globalConfig } = useSearch();
  const [selectedPropertyId, setSelectedPropertyId] = useState(null);
  const propertyCardsRef = useRef(null);
  const navigate = useNavigate();

  // Create display list: selected property always first, then other filtered properties
  const displayProperties = () => {
    if (!selectedPropertyId) {
      return filteredProperties;
    }

    const selectedProperty = properties.find(p => p.id === selectedPropertyId);
    if (!selectedProperty) {
      return filteredProperties;
    }

    // Always show selected property first, then other properties (excluding the selected one)
    const otherProperties = filteredProperties.filter(p => p.id !== selectedPropertyId);
    return [selectedProperty, ...otherProperties];
  };
  
  const handlePropertySelection = (propertyId) => {
    sendPropertySelected(propertyId);

    if (investmentData?.navigatorClickOpensCard) {
      navigate(`/properties/${encodeURIComponent(propertyId)}`);
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    const newSelectedId = selectedPropertyId === propertyId ? null : propertyId;
    setSelectedPropertyId(newSelectedId);
  };

  if (loading) {
    return <div className="loading">Ładowanie właściwości...</div>;
  }

  if (error && error.includes('Nie znaleziono inwestycji')) {
    return <InvestmentNotFound email={globalConfig?.fallback_email} />;
  }

  if (error) {
    return <div className="error">Błąd: {error}</div>;
  }

  return (
    <div className="property-filter-wrapper">
      <div className="property-filter-container">
        <SearchFilters onResetSelection={() => setSelectedPropertyId(null)} />
        
        {/* Property Type Counter */}
        <PropertyTypeCounter />
        
        {/* Interactive Property Map */}
        <InteractivePropertyMap
          properties={allPropertiesForMap} // Pass all properties including parking/storage for map coloring
          filteredProperties={filteredProperties} // Pass filtered properties for comparison
          investmentData={investmentData}
          selectedPropertyId={selectedPropertyId}
          onPropertySelect={handlePropertySelection}
        />

        {/* Property cards */}
        <div className="property-cards" ref={propertyCardsRef}>
          {displayProperties().map((property, index) => {
            const isSelectedFromNavigator = property.id === selectedPropertyId && index === 0;
            return (
            <div 
              key={property.id} 
              data-property-id={property.id} 
              data-status={property.status?.code}
              className={`property-card-wrapper ${isSelectedFromNavigator ? 'selected-from-map' : ''}`}
            >
              <ListingCard
                property={property}
                title={property.title}
                propertyType={property.propertyType}
                propertyTypeLabel={property.propertyTypeLabel}
                statusIcon={property.status.icon}
                image={property.media.main_image}
                isAvailable={true}
                propertyId={property.id}
                onCardClick={null}
              />
            </div>
            );
          })}
        </div>

        {/* Footer */}
        <Footer />
      </div>
    </div>
  );
}

export default function PropertyListingFilter() {
  return <PropertyListingContent />;
}


